import React from 'react'
import MoreInfoButton from '../../../components/Atoms/MoreInfoButton/MoreInfoButton';
import { FaRegEye } from 'react-icons/fa';
import { getTimeAgo } from '../../../_helpers/getTimeAgo';

const Upcoming = ({
    profileUrl = "/img/Rectangle 1614423849.png",
    userIdName = "Huzaifa Khan",
    kycCreatedDate = "Feb 15, 2025",
    userKycEmail = "huzaifa@gmail.com",
    kycIpAddress = "12:254:121:200",
    kycCountry = "UK",
    kycCountryFlagUrl = "/img/flag.png",
    kycDcoOne = "/img/Group 1597881797.png",
    kycDocTwo = "/img/Rectangle 1614423845.png",
    kycDocNumber = "36985214758",
    kycDocDate2 = "12/10/2026",
    kycAddressDoc = "/img/image.png",
    statusTitle,
    handleMoreInfoClick,
    activeButton,
    // verifiedBy,
    handleAction, id, date, kycAddressProofDocumentName
}) => {

    console.log(kycAddressProofDocumentName)

    const renderIconsAndText = () => {
        switch (statusTitle) {
            case 'Upcoming':
                return (
                    <div className="flex gap-1">

                    </div>
                );

            case 'Expired':
                return (
                    <div>
                        {/* <span className="text-md font-[500] text-[#F6465D]">
                            By ({verifiedBy?.userName || "N/A"} , {verifiedBy?.employeeId || "N/A"})
                        </span> */}
                    </div>
                );
            default:
                return <p>No Data Found</p>;
        }
    };
    return (
        <>
            <div className="flex items-center justify-between p-4 border-[1px] border-[#D2D2D2] rounded-xl">
                <div className="flex items-center gap-2">
                    <span className="font-medium text-[#F6465D]">{statusTitle}</span>
                    {renderIconsAndText()}
                    <button onClick={() => handleAction(id)}>
                        <FaRegEye className="text-[22px] text-blue-500" title='View' />
                    </button>
                </div>
                <span className="text-sm text-[#F6465D] font-[500]">{getTimeAgo(date)}</span>
            </div>
            <div className="flex flex-col w-full mx-auto overflow-hidden border border-gray-200 rounded-lg shadow-sm md:flex-row">
                <div className="w-full p-4 border-b border-gray-200 md:border-b-0 md:border-r">
                    <div className="">
                        <div className="flex items-center justify-center mt-4">
                            <img src={profileUrl} alt='profile' className='border-2 border-[#00811D] rounded-lg h-[21rem] w-[25rem]'
                                onError={(e) => e.target.src = '/img/Group 1597881797.png'} />
                        </div>
                    </div>
                    <div className="mt-4 space-y-3">
                        <div className='flex justify-between'>
                            <h2 className="text-[18px] font-[500] text-[#1D1F2C] capitalize">{userIdName}</h2>
                            <p className="text-sm text-[#1D1F2CB2]">{kycCreatedDate}</p>
                        </div>
                        <p className="mt-2 text-sm text-[#1D1F2CB2]">{userKycEmail}</p>
                        <div className='flex items-center justify-between'>
                            <p className="mt-1 text-sm text-[#1D1F2CB2]">{kycIpAddress}</p>
                            <div className="flex items-center mt-2 border border-[#D2D2D2]/50 p-1 rounded-lg">
                                <div className="w-6 h-6 mr-2 overflow-hidden rounded-full">
                                    <div className="flex items-center justify-center w-full h-full">
                                        <img src={kycCountryFlagUrl} alt='' />
                                    </div>
                                </div>
                                <span className="text-xs text-[#1D1F2CB2]">{kycCountry}</span>
                            </div>
                        </div>
                    </div>
                    {activeButton === 'more-info' ? <MoreInfoButton handleMoreInfoClick={handleMoreInfoClick} className={"mt-2"} /> : null}
                </div>

                <div className="w-full p-4 border-b border-gray-200 md:border-b-0 md:border-r">
                    <div className="flex flex-col space-y-4">
                        <div className="p-4 space-y-2">
                            <img src={kycDcoOne} alt='kycDocOne' className='w-[20rem] h-[10rem] border-2 border-[#00811D] rounded-lg'
                                onError={(e) => e.target.src = '/img/Group 1597881797.png'} />
                            <img src={kycDocTwo} alt='kycDocTwo' className='w-[20rem] h-[10rem] border-2 border-[#00811D] rounded-lg'
                                onError={(e) => e.target.src = '/img/Group 1597881797.png'} />
                        </div>
                        <div className='p-2 ml-3 space-y-2'>
                            <p className="text-[14px] font-[500] text-[#1D1F2CB2]">{kycDocNumber}</p>
                            <p className="text-[14px] font-[500] text-[#1D1F2CB2]">{kycDocDate2}</p>
                        </div>
                    </div>
                </div>

                <div className='w-full p-4 mt-3 space-y-3'>
                    <img src={kycAddressDoc} alt='doc1' className='h-[21rem] w-[25rem] border-2 border-[#00811D] rounded-lg mx-auto'
                        onError={(e) => e.target.src = '/img/Group 1597881797.png'} />
                    <div className='flex justify-between place-items-center'>
                        <p className='text-[14px] font-[500] text-[#1D1F2CB2]'> Document Name</p>
                        <p className='text-[14px] font-[500] text-[#1D1F2CB2]'>{kycAddressProofDocumentName}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Upcoming